import React from 'react';
import {
    fetchTransactionsAntigoon,
    formatAmount,
    isTableHeaderNormalType,
    startTransactionsAntigoonDownload
} from "../../services";
import {transactionAntigoonColumns} from "../../components/Table/columns";
import GenericTableScreenWrapper from "../GenericTableScreen/GenericTableScreenWrapper";
import GenericTablePrimaryLink from "../../components/GenericTablePrimaryLink/GenericTablePrimaryLink";

const TransactionsAntigoonScreenWrapper = () => {
    const renderers: TableRenderers<TransactionAntigoonTableType> = {
        referenceId: (item) => <GenericTablePrimaryLink to={`/transactions-antigoon/${item.referenceId}`}/>,
        amount: (item) => formatAmount(item.amount),
    };

    return (
        <GenericTableScreenWrapper
            title="Transactions"
            columns={Object.values(transactionAntigoonColumns).filter(isTableHeaderNormalType)}
            fetchFunction={fetchTransactionsAntigoon}
            itemKey="referenceId"
            storageKey="transactionsAntigoon"
            renderers={renderers}
            startDownloadFunction={startTransactionsAntigoonDownload}
        />
    );
};

export default TransactionsAntigoonScreenWrapper;
